import React, { useEffect, useState } from "react";
import "./amthal.css";
export default function Amthal() {
  const [mathal, setMathal] = useState({});
  const [amthal, setAmthal] = useState([]);
  const [display, setDisplay] = useState(false);

  const getAmthal = async () => {
    const response = await fetch(
      "https://personal-server-bay.vercel.app/api/data/randoms"
    );
    const data = await response.json();
    setAmthal(data);
  };

  const toggle = () => {
    setDisplay((prev) => !prev);
    console.log(display);
  };

  useEffect(() => {
    fetch("https://personal-server-bay.vercel.app/api/data/random")
      .then((response) => response.json())
      .then((data) => setMathal(data))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <div className="amthal">
      <h2>مثل اليوم</h2>
      <div className="amthal-content">
        <p>{mathal.title}</p>

        <h3> هل تريد المزيد من الامثال ؟</h3>
        {display ? (
          <button className="btn btn-outline-success" onClick={() => toggle()}>
            اخفاء
          </button>
        ) : (
          <button
            className="btn btn-outline-success"
            onClick={() => {
              toggle();
              getAmthal();
            }}
          >
            عرض المزيد
          </button>
        )}

        {display &&
          amthal.map((item) => {
            return <p key={item.id}> {item.title} </p>;
          })}
      </div>
    </div>
  );
}
